import React, { Component } from 'react'
import Accordion from 'apa/components/Accordion'
import CheckpointList from 'catalog/containers/CheckpointList'
import CategoryEdit from 'catalog/components/CategoryEdit'
import CategoryIntroduction from 'catalog/components/CategoryIntroduction'
import CategoryResources from 'catalog/components/CategoryResources'

export default class CategoryDetail extends Component {
    render() {
        return (
            <Accordion>
                <CategoryEdit />
                <CategoryIntroduction />
                <CheckpointList />
                <CategoryResources />
            </Accordion>
        )
    }
}

